import React from 'react';

function AboutUs() {
  return (
    <div>
      <div className="header user-header">
        <div className="container">
          <h1>About Coupon Adda</h1>
        </div>
      </div>

      <div className="container">
        <div className="content-page">
          <section>
            <h2>Who We Are</h2>
            <p>
              Coupon Adda is your trusted destination for discovering the best deals, discounts, and coupons
              from top brands across India. We help savvy shoppers save money on their favorite products and services.
            </p>
          </section>

          <section>
            <h2>Our Mission</h2>
            <p>
              Our mission is to make online shopping more affordable and accessible by providing verified,
              up-to-date coupon codes and deals. We believe everyone deserves to get the best value for their money.
            </p>
          </section>

          <section>
            <h2>What We Offer</h2>
            <ul>
              <li><strong>Verified Coupons:</strong> All our coupons are verified before publishing</li>
              <li><strong>Wide Range:</strong> Deals across multiple categories - Food, Fashion, Electronics, Travel & more</li>
              <li><strong>Regular Updates:</strong> Fresh deals added daily</li>
              <li><strong>Easy to Use:</strong> Simple one-click coupon copying</li>
              <li><strong>Mobile-Friendly:</strong> Works seamlessly on all devices</li>
            </ul>
          </section>

          <section>
            <h2>Why Choose Us</h2>
            <p>
              We understand that your time is valuable. That's why we aggregate the best deals from various
              payment apps like GPay, Paytm, and PhonePe, as well as direct website offers, all in one place.
              No more hunting across multiple platforms - find everything you need right here.
            </p>
          </section>

          <section>
            <h2>Contact Us</h2>
            <p>
              Have questions or suggestions? We'd love to hear from you! Visit our <a href="/contact">Contact page</a> to get in touch.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}

export default AboutUs;
